import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import AutoComplete from '../select/AutoComplete';
const messages = defineMessages({
    ToDo: {
        id: 'ToDo',
        defaultMessage: 'To do',
    },
    InProgress: {
        id: 'InProgress',
        defaultMessage: 'In progress',
    },
    Done: {
        id: 'Done',
        defaultMessage: 'Done',
    },
    Blocked: {
        id: 'Blocked',
        defaultMessage: 'Blocked',
    },
    NotDone: {
        id: 'NotDone',
        defaultMessage: 'NotDone',
    },
    Inapplicable: {
        id: 'Inapplicable',
        defaultMessage: 'Inapplicable',
    },
    Rejected: {
        id: 'Rejected',
        defaultMessage: 'Rejected',
    },
});
export const StatusSelect = ({ initialValue, placeholder, onChange }) => {
    const { formatMessage } = useIntl();
    const statuses = useMemo(() => [
        {
            key: 0,
            label: formatMessage(messages.ToDo),
        },
        {
            key: 1,
            label: formatMessage(messages.InProgress),
        },
        {
            key: 2,
            label: formatMessage(messages.Done),
        },
        {
            key: 4,
            label: formatMessage(messages.Inapplicable),
        },
        {
            key: 6,
            label: formatMessage(messages.Rejected),
        },
        {
            key: -1,
            label: formatMessage(messages.NotDone),
        },
    ], [formatMessage]);
    const initialSelectedItem = useMemo(() => initialValue || parseInt(initialValue) === 0
        ? statuses.find(item => (item === null || item === void 0 ? void 0 : item.key) === parseInt(initialValue))
        : undefined, [initialValue, statuses]);
    return (_jsx(AutoComplete, { items: statuses, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: item => onChange(item === null || item === void 0 ? void 0 : item.key) }));
};
export const FilterStatusSelect = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: (_jsx(StatusSelect, { onChange: value => setFilter({ [item]: value !== null && value !== void 0 ? value : undefined }), initialValue: activeFilters[item], placeholder: label })),
});
